import React from 'react';
import { Loader2 } from 'lucide-react';
import { CustomSelect } from '../../components/CustomSelect';

interface LanguageAndRegionProps {
  selectedTimezone: number;
  selectedLanguage: string;
  updatingTimezone: boolean;
  onTimezoneChange: (timezone: number) => void;
  onLanguageChange: (language: string) => void;
}

export const LanguageAndRegion: React.FC<LanguageAndRegionProps> = ({
  selectedTimezone,
  selectedLanguage,
  updatingTimezone,
  onTimezoneChange,
  onLanguageChange,
}) => {
  return (
    <div className="bg-surface-card rounded-lg border border-neutral-200">
      <div className="p-5 border-b border-neutral-200">
        <h2 className="text-[17px] font-semibold text-brand-black/90">Idioma y Región</h2>
        <p className="text-[13px] text-neutral-500 mt-0.5">
          Configura el idioma y la zona horaria
        </p>
      </div>
      
      <div className="p-5 space-y-5">
        {/* Timezone selection */}
        <div>
          <label className="block text-[13px] font-medium text-neutral-600 mb-1.5">
            Zona horaria
          </label>
          <CustomSelect
            options={[
              { value: '-12', label: 'UTC-12:00' },
              { value: '-11', label: 'UTC-11:00' },
              { value: '-10', label: 'UTC-10:00' },
              { value: '-9', label: 'UTC-09:00' },
              { value: '-8', label: 'UTC-08:00' },
              { value: '-7', label: 'UTC-07:00' },
              { value: '-6', label: 'UTC-06:00' },
              { value: '-5', label: 'UTC-05:00' },
              { value: '-4', label: 'UTC-04:00' },
              { value: '-3', label: 'UTC-03:00 (Buenos Aires)' },
              { value: '-2', label: 'UTC-02:00' },
              { value: '-1', label: 'UTC-01:00' },
              { value: '0', label: 'UTC+00:00' },
              { value: '1', label: 'UTC+01:00' },
              { value: '2', label: 'UTC+02:00' },
              { value: '3', label: 'UTC+03:00' },
              { value: '4', label: 'UTC+04:00' },
              { value: '5', label: 'UTC+05:00' },
              { value: '6', label: 'UTC+06:00' },
              { value: '7', label: 'UTC+07:00' },
              { value: '8', label: 'UTC+08:00' },
              { value: '9', label: 'UTC+09:00' },
              { value: '10', label: 'UTC+10:00' },
              { value: '11', label: 'UTC+11:00' },
              { value: '12', label: 'UTC+12:00' },
            ]}
            value={String(selectedTimezone)}
            onChange={(v) => onTimezoneChange(parseInt(v))}
            disabled={updatingTimezone}
          />
          {updatingTimezone && (
            <div className="mt-1.5 flex items-center gap-2 text-brand-primary">
              <Loader2 className="w-3.5 h-3.5 animate-spin" />
              <span className="text-[13px]">Actualizando zona horaria...</span>
            </div>
          )}
        </div>
        
        {/* Language selection */}
        <div>
          <label className="block text-[13px] font-medium text-neutral-600 mb-1.5">
            Idioma
          </label>
          <CustomSelect
            options={[
              { value: 'es', label: 'Español' },
              { value: 'en', label: 'Inglés (próximamente)', disabled: true },
              { value: 'pt', label: 'Portugués (próximamente)', disabled: true },
            ]}
            value={selectedLanguage}
            onChange={onLanguageChange}
          />
          <p className="mt-1 text-[13px] text-neutral-500">
            Más idiomas estarán disponibles próximamente
          </p>
        </div>
      </div>
    </div>
  );
};
